
let dropdownOpts,
    mobileNav,
    navigation,
    landingPage,
    talkToUsBtn;

const navbar = {

  init() {

    /*
    ==================================================
     CACHE DOM ELEMENTS
    ==================================================
    */

    navigation = document.querySelector('.navbar');
    landingPage = document.querySelector('.landing-page');

    if (navigation) {
      mobileNav = navigation.querySelector('.hamburger-icon');
      dropdownOpts = navigation.querySelectorAll('.navbar-link.dropdown');
      talkToUsBtn = navigation.querySelector('.navbar-list.buttons .talk-to-us');
    }

    if (landingPage) {
      this.manageColorMode();
      this.manageDarkNavbarBorder();
    }

    if (mobileNav) {
      this.wireMobileNav();
    }

    if (dropdownOpts) {
      this.wireDropdownOpts();
    }

    if (talkToUsBtn) {
      this.wireTalkToUsBtn();
    }
  },

  /*
  ==================================================
    WIRE BEHAVIORS
  ==================================================
  */

  wireMobileNav() {
    // NOTE: Also, for every "wire" or "startMonitor" method, there should be a corresponding "clear" or "stopMonitor" method to remove the event listeners (if possible)
    mobileNav.addEventListener('click', (e) => {
      this.handleHamburgerClick(e);
    });
  },

  wireDropdownOpts() {
    if (!navigation) return;
  
    navigation.addEventListener('click', (e) => {
      const container = e.target.closest('.navbar-link.dropdown');
      if (!container || !navigation.contains(container)) return;
  
      if (e.target.closest('.dropdown-option')) return;
  
      this.handleDropdownClick(e, container);
    });
  },

  wireTalkToUsBtn() {
    const target = document.querySelector('.cms-content .band-1');
    if (!talkToUsBtn || !target) return;

    const handleIntersection = (entries) => {
      for (const entry of entries) {
        const shouldHide = entry.isIntersecting;
        talkToUsBtn.classList.toggle('is-hidden', shouldHide);
      }
    };

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    };

    const observer = new IntersectionObserver(handleIntersection, options);
    observer.observe(target);
  },

  /*
  ==================================================
   EVENT HANDLERS
  ==================================================
  */

  handleDropdownClick(e, elem) {
    e.preventDefault();
    e.stopPropagation();
    if (!elem) return;

    this.closeOtherDropdowns(elem);
    this.isDropdownMenuOpen(elem) ? this.closeDropdownMenu(elem) : this.openDropdownMenu(elem);
  },
  
  handleHamburgerClick(e) {
    e.preventDefault();
    e.stopPropagation();
  
    const hamburger = e.currentTarget;
    const isOpen = navigation.classList.contains('menu');
  
    if (isOpen) {
      this.closeMobileMenu();
    } else {
      this.openMobileMenu();
    }
  
    hamburger.classList.toggle('is-active', !isOpen);
  },
  
  handleOutsideClick(e, elem) {
    if (elem && elem.contains(e.target)) return;
    this.closeDropdownMenu(elem);
  },

  /*
  ==================================================
   LOCAL UTILS
  ==================================================
  */

  closeDropdownMenu(elem) {
    if (!elem) return;
    elem.classList.remove('is-open');
    this.stopOutsideClickMonitor(elem);
  },
  
  closeMobileMenu() {
    navigation.classList.remove('is-open', 'menu');
    this.setBodyMobileNav(false);
    this.optionsContainer().classList.remove('is-showing');
  },
  
  closeOtherDropdowns(selectedDropdown) {
    const otherDropdowns = document.querySelectorAll('.navbar .is-open');
    otherDropdowns.forEach((dropdown) => {
      if (dropdown !== selectedDropdown) {
        dropdown.classList.remove('is-open');
        this.stopOutsideClickMonitor(dropdown);
      }
    });
  },  
  
  isDropdownMenuOpen(elem) {
    return !!(elem && elem.classList.contains('is-open'));
  },
  
  manageColorMode() {
    const firstBand = document.querySelector('.band-1');
    if (!firstBand || !navigation) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        navigation.classList.toggle('dark-mode', entry.isIntersecting);
      },
      { threshold: 0 }
    );
  
    observer.observe(firstBand);
  },
  
  manageDarkNavbarBorder() {
    if (!navigation) return;

    let ticking = false;

    const apply = () => {
      navigation.classList.toggle('with-border', window.scrollY > 0);
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(apply);
      }
    }, { passive: true });
  },  
  
  openDropdownMenu(elem) {
    if (!elem) return;
    elem.classList.add('is-open');
    this.startOutsideClickMonitor(elem);
  },
  
  openMobileMenu() {
    navigation.classList.add('is-open', 'menu');
    this.setBodyMobileNav(true);
    this.optionsContainer().classList.add('is-showing');
  },

  optionsContainer() {
    return navigation.querySelector('.options-container');
  },
  
  startOutsideClickMonitor(elem) {
    if (!elem) return;
    const handler = (e) => this.handleOutsideClick(e, elem);
    elem.outsideClickHandler = handler;
    document.addEventListener('click', handler, true);
  },
  
  stopOutsideClickMonitor(elem) {
    if (!elem || !elem.outsideClickHandler) return;
    document.removeEventListener('click', elem.outsideClickHandler, true);
    elem.outsideClickHandler = null;
  },  

  setBodyMobileNav(isOpen) {
    document.body.classList.toggle('mobile-nav-open', !!isOpen);
  },

}

export default navbar;
